import React, { useState, useEffect } from "react";
import { Switch, Select, Tag, Modal } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import moment from "moment/min/moment-with-locales";
import {
  listUser,
  changeStatus,
  changeRole,
  removeUser,
  resetPassword,
} from "../../function/users";

import "./ManageAdmin.css"; // นำเข้าไฟล์ CSS ที่สร้างขึ้น

const ManageAdmin = () => {
  const { user } = useSelector((state) => ({ ...state }));

  // ข้อมูลในตาราง ต้นฉบับ
  const [data, setData] = useState([]);
  console.log("data", data);
  // ข้อมูลที่เลือก
  const [selectData, setSelectData] = useState([]);
  //ข้อมูลที่ใช้ loop ใน dropdown
  const [drop, setDrop] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [values, setValues] = useState({
    id: "",
    password: "",
  });

  const [lastResetInfo, setLastResetInfo] = useState(null);

  const showModal = (id, username) => {
    console.log("showModal called", id, username);
    setValues({ id: id, password: "" });
    setLastResetInfo(null); // clear ค่าเก่า
    setIsModalOpen(true);
  };
  const handleChangePassword = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const handleOk = () => {
    setIsModalOpen(false);
    resetPassword(user.token, values.id, { values })
      .then((res) => {
        setLastResetInfo({
          id: values.id,
          password: values.password,
        });
        loadData(user.token);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    loadData(user.token);
  }, []);

  const loadData = (authtoken) => {
    listUser(authtoken)
      .then((res) => {
        setData(res.data);
        setSelectData(res.data);
        // [...new Set(array)]
        const dataDrop = [...new Set(res.data.map((item) => item.role))];
        setDrop(dataDrop);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };

  const handleOnchange = (e, id) => {
    const value = {
      id: id,
      enabled: e,
    };
    changeStatus(user.token, value)
      .then((res) => {
        console.log(res);
        loadData(user.token);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const handlechangeRole = (e, id) => {
    let values = {
      id: id,
      role: e,
    };

    changeRole(user.token, values)
      .then((res) => {
        console.log(res);
        loadData(user.token);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };
  const handleRemove = (id) => {
    if (window.confirm("Are You Sure Delete!!")) {
      removeUser(user.token, id)
        .then((res) => {
          console.log(res);
          loadData(user.token);
        })
        .catch((err) => {
          console.log(err.response);
        });
    }
  };
  const roleData = ["admin", "user", "employee", "staff"];
  const handleSelectRole = (e) => {
    const value = e.target.value;
    if (value === "all") {
      setSelectData(data);
      setSelectedCount(data.length);
    } else {
      const filterData = data.filter((item) => item.role === value);
      setSelectData(filterData);
      setSelectedCount(filterData.length);
    }
  };

  return (
    <div>
      <div className="Manage">
        <h3>ManageAdmin </h3>
        <select onChange={(e) => handleSelectRole(e)}>
          <option value="all">all</option>
          {drop.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
        <span style={{ marginLeft: 10 }}>
          {selectedCount > 0 && (
            <Tag color="blue">จำนวน {selectedCount} คน</Tag>
          )}
        </span>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">username</th>
              <th scope="col">email</th>
              <th scope="col">role</th>
              <th scope="col">status</th>
              <th scope="col">created</th>
              <th scope="col">updated</th>
              <th scope="col">action</th>
            </tr>
          </thead>
          <tbody>
            {selectData.map((item, index) => (
              <tr>
                <th scope="row">{item.username}</th>
                <td>{item.email}</td>
                <td>
                  <Select
                    style={{ width: "100%" }}
                    value={item.role}
                    onChange={(e) => handlechangeRole(e, item._id)}
                  >
                    {roleData.map((item, index) => (
                      <Select.Option value={item} key={index}>
                        {item === "admin" ? (
                          <Tag color="pink">{item}</Tag>
                        ) : item === "user" ? (
                          <Tag color="green">{item}</Tag>
                        ) : item === "employee" ? (
                          <Tag color="blue">{item}</Tag>
                        ) : item === "staff" ? (
                          <Tag color="yellow">{item}</Tag>
                        ) : (
                          <Tag>{item}</Tag> // ค่าอื่น ๆ ที่ไม่ได้กำหนดสี
                        )}
                      </Select.Option>
                    ))}
                  </Select>
                </td>
                <td>
                  <Switch
                    checked={item.enabled}
                    onChange={(e) => handleOnchange(e, item._id)}
                  />
                </td>
                <td>{moment(item.createdAt).locale("th").format("ll")}</td>
                <td>
                  {moment(item.updatedAt)
                    .locale("th")
                    .startOf(item.updatedAt)
                    .fromNow()}
                </td>

                <td>
                  <DeleteOutlined onClick={() => handleRemove(item._id)} />
                  <EditOutlined
                    onClick={() => showModal(item._id, item.username)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Modal กรอก password ใหม่ */}
      <Modal
        title="Reset Password"
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ disabled: !values.password }} // กันกด ok ตอนไม่ได้กรอก
      >
        <p>New Password :</p>
        <input
          onChange={handleChangePassword}
          type="text"
          name="password"
          value={values.password}
          placeholder="กรอก password ใหม่"
          style={{ width: "100%", padding: "4px 8px" }}
        />
      </Modal>

      {/* Modal แสดง password หลัง reset สำเร็จ */}
      <Modal
        title="✅ Reset Password สำเร็จ"
        open={!!lastResetInfo}
        onOk={() => setLastResetInfo(null)}
        onCancel={() => setLastResetInfo(null)}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <p>Password ใหม่คือ:</p>
        <p
          style={{
            background: "#f5f5f5",
            padding: "8px 12px",
            borderRadius: 6,
            fontFamily: "monospace",
            fontSize: 16,
            letterSpacing: 1,
          }}
        >
          {lastResetInfo?.password}
        </p>
        <p style={{ color: "#999", fontSize: 12 }}>
          * แจ้ง user ให้เปลี่ยน password หลัง login ด้วย
        </p>
      </Modal>
    </div>
  );
};

export default ManageAdmin;